"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriesService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class CategoriesService {
    constructor(baseApiPath) {
        this.baseApiPath = baseApiPath;
    }
    fetch(categoriesFetchPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseApiPath}hotel_billing/menu_items/category/list?page=${categoriesFetchPayload.pageNumber}&limit=${categoriesFetchPayload.limit}`;
                const response = yield axios_1.default
                    .get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const respData = response.data.data;
                return respData;
            }
            catch (error) {
                throw new Error("Error in fetching categories");
            }
        });
    }
    create(categoriesCreatePayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseApiPath}hotel_billing/menu_items/category/create`;
                categoriesCreatePayload = JSONbig.stringify(categoriesCreatePayload);
                const response = yield axios_1.default.post(url, categoriesCreatePayload, {
                    headers: header
                });
                const respData = response.data.message;
                return respData;
            }
            catch (error) {
                throw new Error("Error in creating categories");
            }
        });
    }
    update(categoriesCreatePayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseApiPath}hotel_billing/menu_items/category/edit`;
                categoriesCreatePayload = JSONbig.stringify(categoriesCreatePayload);
                const response = yield axios_1.default.put(url, categoriesCreatePayload, {
                    headers: header
                });
                const respData = response.data.message;
                return respData;
            }
            catch (error) {
                throw new Error("Error in updating categories");
            }
        });
    }
}
exports.CategoriesService = CategoriesService;
